import { useContext } from 'react';
import { SessionContext, type Session } from '@/context/SessionContext';

/**
 * Сессия, загруженная один раз в RootGate (на весь каркас AppLayout – при
 * переходе между страницами RootGate не перемонтируется, повторных запросов
 * нет). Вызывать только внутри AppLayout – там наличие сессии уже
 * гарантировано гейтом.
 */
export function useSession(): Session {
  const session = useContext(SessionContext);
  if (!session) throw new Error('useSession() вызван вне SessionProvider (вне AppLayout)');
  return session;
}
